"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Builder;

var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/values"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

var _schemaReducer = require("../state/schema-reducer");

var _uiSchemaReducer = require("../state/ui-schema-reducer");

var _schemaStore = require("../state/schema-store");

var _languageStore = require("../state/language-store");

var _uiSchemaStore = require("../state/ui-schema-store");

var _styles = require("@material-ui/core/styles");

var _QuestionContainer = _interopRequireDefault(require("./QuestionContainer"));

var _createBreakpoints = _interopRequireDefault(require("@material-ui/core/styles/createBreakpoints"));

var _SpeedDial = _interopRequireDefault(require("@material-ui/lab/SpeedDial"));

var _SpeedDialIcon = _interopRequireDefault(require("@material-ui/lab/SpeedDialIcon"));

var _SpeedDialAction = _interopRequireDefault(require("@material-ui/lab/SpeedDialAction"));

var _Add = _interopRequireDefault(require("@material-ui/icons/Add"));

var _RadioButtonChecked = _interopRequireDefault(require("@material-ui/icons/RadioButtonChecked"));

var _CheckBox = _interopRequireDefault(require("@material-ui/icons/CheckBox"));

var _Subject = _interopRequireDefault(require("@material-ui/icons/Subject"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  var breakpoints = (0, _createBreakpoints.default)({});
  return {
    addQuestion: (0, _defineProperty2.default)({
      border: "dashed ".concat(theme.palette.primary.main, " 1px"),
      color: theme.palette.primary.main,
      padding: "15px 0px"
    }, breakpoints.down("sm"), {
      visibility: "hidden"
    }),
    paper: {
      padding: theme.spacing(2)
    },
    button: {
      padding: "15px 0px"
    },
    speedDial: (0, _defineProperty2.default)({
      position: "fixed",
      bottom: theme.spacing(2),
      right: theme.spacing(2),
      display: "none"
    }, breakpoints.down("sm"), {
      display: "inline-flex"
    }),
    desktopActions: (0, _defineProperty2.default)({}, breakpoints.down("sm"), {
      visibility: "hidden"
    }),
    actions: (0, _defineProperty2.default)({
      display: "flex"
    }, breakpoints.down("sm"), {
      display: "none" // width: 0,
      // height: 0,
      // margin: 0,
      // padding: 0

    })
  };
});

function getIcon(label) {
  if (label === "RADIO") return /*#__PURE__*/_react.default.createElement(_RadioButtonChecked.default, null);
  if (label === "CHECKBOX") return /*#__PURE__*/_react.default.createElement(_CheckBox.default, null);
  if (label === "OPEN_ENDED") return /*#__PURE__*/_react.default.createElement(_Subject.default, null);
  return "Unknown";
}

function Builder(_ref) {
  var _Object$values;

  var onChange = _ref.onChange;

  var _useContext = (0, _react.useContext)(_schemaStore.SchemaContext),
      _useContext2 = (0, _slicedToArray2.default)(_useContext, 2),
      schema = _useContext2[0],
      schemaDispatch = _useContext2[1];

  var _useContext3 = (0, _react.useContext)(_uiSchemaStore.UiSchemaContext),
      _useContext4 = (0, _slicedToArray2.default)(_useContext3, 1),
      uiSchema = _useContext4[0];

  var _useContext5 = (0, _react.useContext)(_languageStore.LanguageContext),
      _useContext6 = (0, _slicedToArray2.default)(_useContext5, 1),
      language = _useContext6[0];

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      collapseAll = _useState2[0],
      setCollapseAll = _useState2[1];

  var classes = useStyles();
  (0, _react.useEffect)(function () {
    onChange({
      schema: schema,
      uiSchema: uiSchema
    });
  }, [schema, uiSchema]);

  function updateFeild(e, type) {
    schemaDispatch({
      type: type,
      payload: e.target.value
    });
  }

  return /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_core.Paper, {
    className: classes.paper
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 3
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h5"
  }, language.questionnaireDetailsTitle)), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    md: 8
  }, /*#__PURE__*/_react.default.createElement(_core.TextField, {
    size: "small",
    label: "".concat(language.questionnaireDetailsTitleLabel),
    name: "title",
    type: "text",
    variant: "outlined",
    onChange: function onChange(e) {
      return updateFeild(e, _schemaReducer.TYPES.QUESTIONNAIRE_TITLE);
    },
    value: schema.title,
    required: true,
    fullWidth: true
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_core.TextField, {
    size: "small",
    fullWidth: true,
    multiline: true,
    label: "".concat(language.questionnaireDetailsDescriptionLabel),
    name: "title",
    type: "text",
    variant: "outlined",
    onChange: function onChange(e) {
      return updateFeild(e, _schemaReducer.TYPES.QUESTIONNAIRE_DESCRIPTION);
    },
    value: schema.description,
    required: true
  }))))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 3
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 3
  }, (_Object$values = (0, _values.default)(schema === null || schema === void 0 ? void 0 : schema.properties)) === null || _Object$values === void 0 ? void 0 : (0, _map.default)(_Object$values).call(_Object$values, function (question, index) {
    return /*#__PURE__*/_react.default.createElement(_QuestionContainer.default, {
      key: index,
      index: index,
      question: question,
      questionUi: uiSchema[index],
      collapseAll: collapseAll
    });
  }))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    direction: "column",
    spacing: 2
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(Actions, null)), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true
  }, (0, _values.default)(schema === null || schema === void 0 ? void 0 : schema.properties).length > 0 && /*#__PURE__*/_react.default.createElement(_core.Button, {
    onClick: function onClick() {
      return setCollapseAll(!collapseAll);
    },
    variant: "outlined",
    color: "primary",
    fullWidth: true,
    className: classes.button
  }, language.questionCollapseAll)))))));
}

function Actions() {
  var _context, _context2;

  var _useContext7 = (0, _react.useContext)(_schemaStore.SchemaContext),
      _useContext8 = (0, _slicedToArray2.default)(_useContext7, 2),
      schemaDispatch = _useContext8[1];

  var _useContext9 = (0, _react.useContext)(_uiSchemaStore.UiSchemaContext),
      _useContext10 = (0, _slicedToArray2.default)(_useContext9, 2),
      uiCchemaDispatch = _useContext10[1];

  var _useContext11 = (0, _react.useContext)(_languageStore.LanguageContext),
      _useContext12 = (0, _slicedToArray2.default)(_useContext11, 1),
      language = _useContext12[0];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      showOptions = _useState4[0],
      setShowOptions = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      speedDialOpen = _useState6[0],
      setSpeedDialOpen = _useState6[1];

  var classes = useStyles();

  function getLabel(label) {
    if (label === "RADIO") return language.selectionQuestion;
    if (label === "CHECKBOX") return language.checkboxQuestion;
    if (label === "OPEN_ENDED") return language.textFieldQuestion;
    return "Unknown";
  }

  function dispatch(k) {
    schemaDispatch({
      type: _schemaReducer.TYPES.ADD_QUESTION,
      payload: _schemaReducer.TEMPLATE[k]
    });
    uiCchemaDispatch({
      type: _uiSchemaReducer.TYPES.ADD,
      payload: _uiSchemaReducer.TEMPLATE[k]
    });
    setShowOptions(!showOptions);
  }

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_SpeedDial.default, {
    ariaLabel: "SpeedDial openIcon example",
    className: classes.speedDial // hidden={hidden}
    ,
    icon: /*#__PURE__*/_react.default.createElement(_SpeedDialIcon.default, {
      openIcon: /*#__PURE__*/_react.default.createElement(_Add.default, null)
    }),
    onClose: function onClose() {
      return setSpeedDialOpen(!speedDialOpen);
    },
    onOpen: function onOpen() {
      return setSpeedDialOpen(!speedDialOpen);
    },
    open: speedDialOpen
  }, (0, _map.default)(_context = (0, _keys.default)(_schemaReducer.TEMPLATE)).call(_context, function (k) {
    return /*#__PURE__*/_react.default.createElement(_SpeedDialAction.default, {
      key: k,
      icon: getIcon(k),
      tooltipTitle: getLabel(k),
      tooltipOpen: true,
      onClick: function onClick() {
        dispatch(k);
        setSpeedDialOpen(!speedDialOpen);
      }
    });
  })), showOptions && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 3,
    className: classes.desktopActions
  }, (0, _map.default)(_context2 = (0, _keys.default)(_schemaReducer.TEMPLATE)).call(_context2, function (k) {
    return /*#__PURE__*/_react.default.createElement(_core.Grid, {
      key: k,
      item: true,
      xs: 12 / (0, _keys.default)(_schemaReducer.TEMPLATE).length
    }, /*#__PURE__*/_react.default.createElement(_core.Button, {
      color: "primary",
      variant: "contained",
      fullWidth: true,
      onClick: function onClick() {
        return dispatch(k);
      }
    }, getLabel(k)));
  })), !showOptions && /*#__PURE__*/_react.default.createElement(_core.Button, {
    fullWidth: true,
    className: classes.addQuestion,
    onClick: function onClick() {
      return setShowOptions(!showOptions);
    }
  }, language.questionAddQuestionLabel));
}